module.exports = __webpack_public_path__ + "assets/img/btn-detail-8f600cad.png";